import { getTokenDefinition, } from "@bracket/chainography";
import type { TokenIdentifier } from "@bracket/types";



/**
 * Checks if a token is a native token
 * @todo: move this to @bracket/helpers
 * @param {TokenIdentifier} token - The token identifier to check
 * @returns {boolean} True if the token is ETH or WETH, false otherwise
 */
export const isNativeToken = ( token: TokenIdentifier) => {
  const tok = getTokenDefinition(token);
  return ["ETH", "WETH"].includes(tok.symbol);
};